import { render, staticRenderFns } from "./bijiao.vue?vue&type=template&id=3596a8a1&scoped=true&"
import script from "./bijiao.vue?vue&type=script&lang=js&"
export * from "./bijiao.vue?vue&type=script&lang=js&"
import style0 from "./bijiao.vue?vue&type=style&index=0&id=3596a8a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3596a8a1",
  null
  
)

export default component.exports